"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectSpread10 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _redux = require("redux");

var _default = function _default(scaffold) {
  var _scaffold$types = (0, _slicedToArray2["default"])(scaffold.types, 4),
      RESET = _scaffold$types[0],
      LOAD = _scaffold$types[1],
      SUCCESS = _scaffold$types[2],
      FAILURE = _scaffold$types[3];

  var data = function data() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (action.type === SUCCESS) {
      return (0, _objectSpread10["default"])({}, state, (0, _defineProperty2["default"])({}, action.key || 'default', scaffold.transformData(action.data)));
    }

    if (action.type === RESET) {
      return (0, _objectSpread10["default"])({}, state, (0, _defineProperty2["default"])({}, action.key || 'default', null));
    }

    return state;
  };

  var error = function error() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (action.type === FAILURE) {
      return (0, _objectSpread10["default"])({}, state, (0, _defineProperty2["default"])({}, action.key || 'default', action.data));
    }

    if (action.type === SUCCESS || action.type === RESET) {
      return (0, _objectSpread10["default"])({}, state, (0, _defineProperty2["default"])({}, action.key || 'default', null));
    }

    return state;
  };

  var loading = function loading() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (action.type === LOAD) {
      var _objectSpread6;

      return (0, _objectSpread10["default"])({}, state, (_objectSpread6 = {}, (0, _defineProperty2["default"])(_objectSpread6, action.key || 'default', true), (0, _defineProperty2["default"])(_objectSpread6, "lastKey", action.key || 'default'), _objectSpread6));
    }

    if (action.type === SUCCESS || action.type === FAILURE || action.type === RESET) {
      return (0, _objectSpread10["default"])({}, state, (0, _defineProperty2["default"])({}, action.key || 'default', false));
    }

    return state;
  };

  var loaded = function loaded() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (action.type === RESET) {
      return (0, _objectSpread10["default"])({}, state, (0, _defineProperty2["default"])({}, action.key || 'default', false));
    }

    if (action.type === SUCCESS) {
      var _objectSpread9;

      return (0, _objectSpread10["default"])({}, state, (_objectSpread9 = {}, (0, _defineProperty2["default"])(_objectSpread9, action.key || 'default', true), (0, _defineProperty2["default"])(_objectSpread9, "lastKey", action.key || 'default'), _objectSpread9));
    }

    return state;
  };

  return (0, _redux.combineReducers)({
    data: data,
    error: error,
    loading: loading,
    loaded: loaded
  });
};

exports["default"] = _default;